import { ReactElement } from "react";
import { Flex } from "@chakra-ui/react";
import { useModifiedTranslation } from "../../../hooks/useModifiedTranslation";
import { CategoryMark } from "./CategoryMark";
import {
  CATEGORY_COLORS,
  NOTIFICATION_CATEGORIES,
  NotificationCategory,
} from "./notificationTypes";

/*
 * 種別の絞り込みチップ。押すたびにオン/オフが切り替わる。
 * オフの地は透明にして、明るいテーマでは白く、ダークテーマではページの地になじませる
 */
export function NotificationCategoryChips(
  props: Readonly<{
    enabled: Record<NotificationCategory, boolean>;
    onToggle: (category: NotificationCategory) => void;
  }>,
): ReactElement {
  const { enabled, onToggle } = props;
  const t = useModifiedTranslation();

  return (
    <Flex wrap="wrap" justify="space-between" gap={2} py={3}>
      {NOTIFICATION_CATEGORIES.map((category) => {
        const isOn = enabled[category];
        const colors = CATEGORY_COLORS[category];
        return (
          <Flex
            key={category}
            as="button"
            type="button"
            align="center"
            gap={1.5}
            pl={1.5}
            pr={3}
            py={1}
            rounded="full"
            borderWidth="1px"
            fontSize="13px"
            fontWeight={isOn ? "bold" : "normal"}
            bg={isOn ? colors.bg : "transparent"}
            color={isOn ? colors.text : "text.sub_text"}
            borderColor={isOn ? colors.text : "gray.300"}
            aria-pressed={isOn}
            onClick={() => onToggle(category)}
            data-testid={`notification-chip-${category}`}
          >
            <CategoryMark category={category} size="chip" isOff={!isOn} />
            {t(`Notification.category.${category}`)}
          </Flex>
        );
      })}
    </Flex>
  );
}
